module.exports = __webpack_public_path__ + "fonts/Lato-Regular.6d4e7822.ttf";